// Instant.page-inspired prefetching
(function () {
  // Skip prefetching on slow or data-saver connections — prefetching six 180KB pages
  // on a slow 3G/4G connection saturates bandwidth and makes the page 10x slower.
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (
    conn &&
    (conn.saveData ||
      ['slow-2g', '2g', '3g'].includes(conn.effectiveType) ||
      (conn.downlink !== undefined && conn.downlink < 1.5))
  ) {
    return;
  }

  const prefetched = new Set();
  let observer;
  const delayOnHover = 65; // Prefetch after 65ms hover

  function prefetch(url) {
    if (prefetched.has(url)) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';

    link.onerror = function () {
      prefetched.delete(url);
    };

    document.head.appendChild(link);
    prefetched.add(url);
  }

  function shouldPrefetch(url) {
    // Only prefetch internal links
    if (!url || url.includes('#') || (!url.startsWith('/') && !url.includes(location.hostname))) {
      return false;
    }

    // Skip large files
    if (url.match(/\.(zip|pdf|exe|dmg|pkg|deb)$/i)) {
      return false;
    }

    return true;
  }

  let hoverTimer;

  // Desktop: prefetch on hover
  document.addEventListener(
    'mouseover',
    function (e) {
      const link = e.target.closest('a');
      if (!link) return;

      const url = link.getAttribute('href');
      if (!shouldPrefetch(url)) return;

      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        prefetch(url);
      }, delayOnHover);
    },
    { passive: true }
  );

  // Mobile: prefetch on touchstart
  document.addEventListener(
    'touchstart',
    function (e) {
      const link = e.target.closest('a');
      if (!link) return;

      const url = link.getAttribute('href');
      if (!shouldPrefetch(url)) return;

      prefetch(url);
    },
    { passive: true }
  );

  // Prefetch visible links when idle
  if ('IntersectionObserver' in window && 'requestIdleCallback' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const link = entry.target;
            const url = link.getAttribute('href');

            if (shouldPrefetch(url)) {
              requestIdleCallback(
                function () {
                  prefetch(url);
                },
                { timeout: 2000 }
              );
            }

            observer.unobserve(link);
          }
        });
      },
      {
        rootMargin: '200px', // Start prefetching 200px before link is visible
      }
    );

    // Observe important links after page load
    window.addEventListener('load', function () {
      setTimeout(function () {
        const links = document.querySelectorAll('a[href^="/"]:not([href*="#"])');
        let count = 0;

        links.forEach(function (link) {
          if (count < 10) {
            // Limit to first 10 links
            observer.observe(link);
            count++;
          }
        });
      }, 1000);
    });
  }
})();
